import { FormLayout, InlineStack, Link, Stack } from '@customerio/pluma-components/react';
import { isEmptyString } from '@/utils/string';
import { ConfigTextArea, ConfigTextField, DEFAULT_BUCKET_PATH, UploadPathPreview } from './fields';
import type { ProviderFormProps } from './types';

const AZURE_SAS_DOCS_URL = 'https://docs.customer.io/ms-azure-data-out/';

/**
 * Blob path and shared access signature for an Azure Blob Storage sync.
 *
 * The odd one out: the SAS URL names its own container, so there is no bucket name
 * and no console address to link to — the docs explain generating the URL instead.
 */
export function AzureBlobForm(props: ProviderFormProps) {
  const path = isEmptyString(props.config.bucket_path) ? DEFAULT_BUCKET_PATH : props.config.bucket_path;

  return (
    <FormLayout>
      <ConfigTextField
        form={props}
        field="bucket_path"
        label="Blob path"
        placeholder={DEFAULT_BUCKET_PATH}
        isSecret={false}
        // Alone among the four, this form does not grab focus: it is also the one
        // whose first field is optional, and in the modal it would steal the focus
        // Pluma places on open.
        autofocus={false}
      />

      <UploadPathPreview scheme="azureBlob" path={path} />

      <Stack>
        <InlineStack alignInline="end">
          <Link icon="help" variant="secondary" isExternal={true} href={AZURE_SAS_DOCS_URL}>
            How do I generate an Azure SAS url?
          </Link>
        </InlineStack>

        <ConfigTextArea form={props} field="container_sas_url" label="Blob SAS URL" rows={3} />
      </Stack>
    </FormLayout>
  );
}
